import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { ResourceService } from 'src/app/services/common/resource.service';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { UserService } from 'src/app/services/user.service';
import { Location } from '@angular/common';
import { LoginService } from 'src/app/services/login.service';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  isLoggedIn: any = false;
  resource: any = {};
  isVisbileTagLink: boolean = false;
  fallbackLogo = 'assets/img/logo.png';
  coverPhotoUrl: string | null = null;
  coverPhotoStyle: SafeStyle | null = null;

  logoURL: string = "assets/img/logo.png";
  brandName: string = "On Offer";
  routerLink: string = '/';
  queryParams = {};
  organization_store_Id: any = "";
  id = "";
  web_url = "";
  organizationId: string;
  slug: string;

  get storeId(): string | null {
    return this.findParam(this.router.routerState.snapshot.root, 'storeId');
  }

  showLogo = true;
  showCoverHeader = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private storageService: StorageService,
    private router: Router,
    private location: Location,
    private loginService: LoginService,
    private userInfoService: UserInfoService,
    private userService: UserService,
    private resourceService: ResourceService,
    private campaignsService: CampaignsService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
  ) {
    this.userInfoService.orgId.subscribe(({ id, slug }) => {
      if (id) {
        this.organizationId = id;
        this.slug = slug;
        this.setBrandDetail();
        this.loadHeaderFromQuery();
      }
    })
  }

  ngOnInit(): void {
    this.userInfoService.brandName.next(this.brandName);
    this.loadResoruce();
    this.resourceService.languageSubject.subscribe(response => {
      this.resource = response;
    });

    this.isLoggedIn = this.userInfoService.getLoginFlag();
    this.storageService.loginSubject.subscribe(message => {
      this.isLoggedIn = this.userInfoService.getLoginFlag();
    });

    this.location.subscribe(() => {
      this.setBrandDetail();
    });


    this.setBrandDetail();
    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const queryParams = this.router.parseUrl(this.router.url).queryParams;
        const campaignID = queryParams['campaign'] || '';
        this.id = queryParams['storeId'] || '';
      });

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd), takeUntil(this.destroy$))
      .subscribe((e: any) => {
        const url = e.urlAfterRedirects ?? this.router.url;
        this.showCoverHeader =
          /\/deal(\/|$)/i.test(url) || /featured-product-details/i.test(url);
        // this.showCoverHeader = url.startsWith('/deal') && !url.includes('featured-product-details');
        this.loadHeaderFromQuery();
      });

    this.loadHeaderFromQuery();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private findParam(route: ActivatedRouteSnapshot, key: string): string | null {
    // check current level
    const v = route.paramMap.get(key);
    if (v) return v;

    // go deeper
    for (const child of route.children) {
      const found = this.findParam(child, key);
      if (found) return found;
    }
    return null;
  }

  setBrandDetail() {
    this.logoURL = "assets/img/logo.png";
    this.brandName = "On Offer";
    this.userInfoService.brandName.next(this.brandName);
    this.routerLink = '/';
    this.queryParams = {};
    this.isVisbileTagLink = true;
    this.organization_store_Id = "";

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd), // Only handle NavigationEnd events
        takeUntil(this.destroy$) // Automatically unsubscribe when component is destroyed
      )
      .subscribe((event: NavigationEnd) => {
        if (this.router.url.includes("?")) {
          const queryStringParams = this.router.url
            .split('?')[1]
            .split('&')
            .map(keyValue => keyValue.split('='))
            .reduce<any>((params, [key, value]) => {
              params[key] = value;
              return params;
            }, {});

          if (queryStringParams?.organizationId || this.organizationId) {
            if (this.organization_store_Id != queryStringParams?.organizationId || this.organizationId) {
              this.userService.get_business_user_name(queryStringParams?.organizationId || this.organizationId).subscribe(res => {
                if (res.data) {
                  if (!this.storeId) this.logoURL = res.data.logo;
                  this.brandName = res.data.name;
                  this.userInfoService.brandName.next(this.brandName);
                  this.routerLink = this.organizationId ? `${this.slug}` : '/deal/organization';
                  this.queryParams = this.organizationId ? {} : { organizationId: queryStringParams?.organizationId };
                  this.isVisbileTagLink = false;
                }
                this.organization_store_Id = queryStringParams?.organizationId || this.organizationId;
              });
            }
          }

          if (queryStringParams?.storeId) {
            if (this.organization_store_Id != queryStringParams?.storeId) {
              this.userService.get_store_user_name(queryStringParams?.storeId).subscribe(res => {
                if (res.data) {
                  this.logoURL = res.data.stoLogo;
                  this.brandName = res.data.stoName;
                  this.userInfoService.brandName.next(this.brandName);
                  this.routerLink = '/deal/store';
                  this.queryParams = { storeId: queryStringParams?.storeId };
                  this.isVisbileTagLink = false;
                  this.web_url = res.data.stoWebUrl
                }
                this.organization_store_Id = queryStringParams?.storeId;
              });
            }
          }
        }
      });
  }

  loadResoruce() {
    this.resourceService.loadResoruce().subscribe(
      response => {
        this.resource = response;
      });
  }

  classApplied = false;
  toggleClass() {
    this.classApplied = !this.classApplied;
  }

  onClickMenu(menu: string) {
    this.toggleClass();
    if (menu == "/my-dashboard" || menu == "/contact") {
      const urlTree = this.router.parseUrl(this.router.url);
      const returnUrl = urlTree.queryParams['returnUrl'] ? decodeURIComponent(urlTree.queryParams['returnUrl']) : '';

      if (returnUrl == '') {
        if (urlTree.queryParams?.organizationId || urlTree.queryParams?.storeId || this.organizationId)
          this.router.navigate([menu], { queryParams: { returnUrl: decodeURIComponent(this.router.url) } });
        else
          this.router.navigate([menu]);
      }
      else {
        this.router.navigate([menu], { queryParams: { returnUrl: returnUrl } });
      }
    } else
      this.router.navigate([menu]);
    this.setBrandDetail();
  }

  logout() {
    this.toggleClass();
    this.userInfoService.setToken();
    this.storageService.removeValue(StorageKey.authToken);
    this.storageService.removeValue(StorageKey.currentUser);
    this.storageService.removeValue(StorageKey.rememberMe);
    sessionStorage.removeItem('currentUser');
    this.userInfoService.setLoginFlag(false);
    this.storageService.loginSubject.next(false);
    this.router.navigate(['/']);
    this.setBrandDetail();
    this.loginService.logout();
  }

  /** Turn any API value into a good, absolute, https-safe URL */
  private toAbsoluteUrl(u: string): string {
    if (!u) return '';

    // Already absolute
    if (/^https?:\/\//i.test(u)) {
      // auto-upgrade http->https if page is https (prevents mixed-content block)
      if (location.protocol === 'https:' && /^http:\/\//i.test(u)) {
        return u.replace(/^http:/i, 'https:');
      }
      return u;
    }

    // Protocol-relative //cdn...
    if (u.startsWith('//')) {
      return `${location.protocol}${u}`;
    }

    // Root-relative /path
    if (u.startsWith('/')) {
      return `${location.origin}${u}`;
    }

    // Plain relative path or key
    return `${location.origin}/${u.replace(/^\.?\//, '')}`;
  }

  private setCover(url?: string) {
    const abs = this.toAbsoluteUrl(url || '');
    this.coverPhotoUrl = abs || null;
    this.coverPhotoStyle = abs
      ? this.sanitizer.bypassSecurityTrustStyle(`url("${abs}")`)
      : null;

  }

  private loadHeaderFromQuery(): void {
    this.logoURL = 'assets/img/logo.png';
    this.brandName = 'On Offer';
    this.userInfoService.brandName.next(this.brandName);
    this.web_url = '';
    this.coverPhotoUrl = null;
    this.coverPhotoStyle = null;

    const qp = this.router.parseUrl(this.router.url).queryParams || {};
    const id: string | undefined = qp['organizationId'] || qp['storeId'] || this.organizationId;
    if (!id) return;
    if (this.storeId)
      this.userService.get_store_owner_logo(this.storeId).subscribe(res => {
        if (res.data) {
          this.logoURL = res.data.stoLogo;
        }
      });
    this.userService.profile_cover(id).subscribe({
      next: (res: any) => {
        const d = res?.data ?? res ?? {};

        // keep your fallbacks for logo/name
        if (!this.storeId) this.logoURL = d?.compLogo || d?.logo || this.logoURL;
        this.brandName = d?.name || this.brandName;
        this.userInfoService.brandName.next(this.brandName);
        this.web_url = d?.stoWebUrl || d?.webUrl || '';

        const cover =
          d?.cover_photo ||
          d?.coverPhoto ||
          d?.coverPhotoUrl ||
          d?.cover ||
          d?.bannerImage ||
          '';

        this.setCover(cover);
      },
      error: () => this.setCover('')
    });
  }


  useFallback(ev: Event) {
    const img = ev.target as HTMLImageElement;
    img.onerror = null;
    img.src = this.fallbackLogo;
  }
}